// extracted by mini-css-extract-plugin
export default {"muted":"lXR8O___Emdash-module__muted"};